import { httpClient } from '@/services/http/httpClient'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

type IdeaByWorkflow = {
  name: string
  count: number
}

type Params = {
  challenges?: string[]
}

type Response = {
  workflows: IdeaByWorkflow[]
}

type HttpResponse = {
  workflows: {
    name: string
    count: number
  }[]
}

export async function getDashboardIdeasByWorkflow({
  challenges,
}: Params): Promise<Response> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    await new Promise((resolve) => setTimeout(resolve, 1000))

    return {
      workflows: [
        {
          name: 'Inovação Interna',
          count: 10,
        },
        {
          name: 'Open Innovation',
          count: 10,
        },
        {
          name: 'Quick Win',
          count: 5,
        },
      ],
    }
  }

  const queryParams = new URLSearchParams({
    ...(challenges && { campaignIds: JSON.stringify(challenges) }),
  })

  const query = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data } = await httpClient.get<HttpResponse>(
    `/ideas/dashboard/count-per-workflow-by-kanban${query}`,
  )

  return {
    workflows: data.workflows ?? [],
  }
}
